export default {"src":"/_next/static/media/sub-menu-arrow-light.7ba46c28.svg","height":7,"width":12,"blurWidth":0,"blurHeight":0};